import * as Yup from 'yup'

const customerRefundPaymentFormSchema = Yup.object().shape({
  tl_bank_id: Yup.number()
    .when('refund_method', {
      is   : 'cash',
      then : Yup.number().required('required')
    } ),
  transferred_at: Yup.date()
    .max(new Date(), 'Must today or past date')
    .required('Required')
})

export default customerRefundPaymentFormSchema
